"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogosContent = exports.FooterContent = exports.Footer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Footer = styled_components_1.default.footer `
  display: block;
  border-bottom: 4px solid ${({ theme }) => theme.colors.main.base};

  background-color: ${({ theme }) => theme.colors.gray.s200};
`;
exports.FooterContent = styled_components_1.default.div `
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  padding: ${({ theme }) => theme.space.s500} ${({ theme }) => theme.space.s300};
  margin: 0 auto;

  background-color: ${({ theme }) => theme.colors.gray.s200};

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    padding: ${({ theme }) => theme.space.s400} 110px ${({ theme }) => theme.space.s300} 110px;
  }
`;
exports.LogosContent = styled_components_1.default.div `
  display: flex;

  background-color: ${({ theme }) => theme.colors.white.s100};
`;
